// extracted by mini-css-extract-plugin
export default {"container":"ad-cell-module__container___phfcP","containerTitle":"ad-cell-module__containerTitle___iskqu","ad":"ad-cell-module__ad___xyJuW"};